import { enableProdMode, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, ROUTER_CONFIGURATION } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { ForgerockComponent } from './app/forge-rock.component';
import { appRoutes } from './app/app.routes';
import { forgeRockRoutes } from './app/forge-rock.routes';
import { metaReducers, reducers } from './app/store/reducers';
import { appInitializer } from './app/app.initializer'; // ← your config loader
import { ConfigLoaderService } from './app/shared/services/api-services/configLoader.service';
import { CredentialsInterceptor } from './app/shared/interceptor/credentials.interceptor';

if (environment.production) {
  enableProdMode();
}

const isIframeOrPopup = window !== window.parent && !!window.opener;

const commonProviders = [
  {
    provide: ROUTER_CONFIGURATION,
    useValue: {
      enableTracing: true,
      scrollPositionRestoration: 'top',
      paramsInheritanceStrategy: 'always'
    }
  },
  { provide: LocationStrategy, useClass: HashLocationStrategy },
  provideStore(reducers, { metaReducers }),
  provideHttpClient(withFetch(), withInterceptorsFromDi()),  
  {provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true},
  DatePipe,
  ConfigLoaderService,
  provideAppInitializer(appInitializer)
];

bootstrapApplication(isIframeOrPopup ? ForgerockComponent : AppComponent, {
  providers: [
    provideRouter(isIframeOrPopup ? forgeRockRoutes : appRoutes),
    ...commonProviders
  ]
});
